import styled from 'styled-components';

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
  min-height: 100px;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const AddTagContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  width: 100%;
  align-items: center;
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 32px 0;
  color: #9ca3af;
  font-size: 14px;
`;

